import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Table } from 'reactstrap';
import stores from 'cd-eft/models/Stores';
import { DeleteElement } from '../../common/DeleteElement/DeleteElement';
import { ActionsMenu } from '../../common/ActionsMenu';
import { AlignmentCopy } from '../AlignmentCopy';
import { AlignmentSummaryTableVM, handleCheckboxChange } from './AlignmentSummaryTableVM';
import { Popup } from 'cd-eft/components/common/Popup';
import { mdiExitToApp } from '@mdi/js';
import './AlignmentSummaryTable.scss';
import { DesignSummaryButtons } from 'cd-eft/components/Design/common/DesignSummaryButtons';
import Icon from '@mdi/react';
import { StaticTooltip } from 'cd-eft/components/common/StaticTooltip/StaticTooltip';

const alignmentStore = stores.AppStore.alignmentDesignStore;
const { designStore } = stores.AppStore;
const AlignmentSummaryTableComponent = (props) => {
  const vm = useRef(new AlignmentSummaryTableVM(props)).current;

  useEffect(() => {
    if (designStore.currentSurface.surfaceDefId) {
      vm.getAlignmentsHandler();
    }
  }, [designStore.currentSurface.surfaceDefId]);

  const tooltipStandardMessage =
  'Proceed to Alignment Edit Panel to review digitized Alignment.';

  return (
    <>
      {alignmentStore.summaryTable && (
        <div className="set-table-container width-auto">
          <Table className="set-table">
            <thead>
              <tr>
                <th className="narrow-td">Select</th>
                <th>Name</th>
                <th className="nobr">Design Type</th>
                <th className="narrow-td">Actions</th>
              </tr>
            </thead>
            <tbody>
              {alignmentStore.summaryTable.map((item: any) => {
                return (
                  <tr
                    key={`alignment-${item.designElementId}-${item.designElementName}`}
                    className={alignmentStore.unsavedAlignments.has(item.designElementId) ? 'highlightedRow' : ''}
                  >
                    <td className="text-center">
                      <input
                        id={'select-' + item.designElementId}
                        data-testid={'select-' + item.designElementId}
                        aria-label={'select-' + item.designElementId}
                        name={'select-' + item.designElementId}
                        type="checkbox"
                        checked={alignmentStore.selectedAlignments.has(item.designElementId)}
                        value={item.designElementId}
                        onChange={handleCheckboxChange}
                      />
                    </td>
                    <td>
                      <label htmlFor={'select-' + item.designElementId} className="text-normal m-0 link w-100">
                        {item.designElementName}
                      </label>
                    </td>
                    <td>
                      <div className="design-type"> {vm.alignmentTypes[item.designElementTypeId]}
                        {item.flagUpToDate && (
                          <div className="flag-up-todate"><span className="warning-span"> (Invalid) </span>
                            <div className="hover-text">
                              <StaticTooltip tooltipMessage={tooltipStandardMessage} tooltipSide='left' id="waterway-warnings-tooltip"/>
                            </div></div>
                        )}</div>

                    </td>


                    <td>
                      <ActionsMenu
                        i={`${item.designElementId}-${item.designElementName}`}
                        item={item}
                        elementActions={
                          alignmentStore.unsavedAlignments.has(item.designElementId)
                            ? vm.unsavedAlignmentsActions
                            : item.designElementTypeId === 16 || item.designElementTypeId === 17
                              ? vm.soAlignmentActions
                              : vm.elementActions
                        }
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          {alignmentStore.summaryTable.length === 0 && !alignmentStore.isLoading && !designStore.isLoading && (
            <div className="h4 m-5 text-center">Add your first Alignment</div>
          )}
        </div>
      )}

        <div className="mt-3">
          <button className="usa-button" onClick={vm.addNewAlignmentHandler}>
            Add
          </button>
          <button className="usa-button usa-button--outline float-right mr-0" 
            disabled={alignmentStore.selectedAlignments.size === 0} 
            onClick={vm.displaySelectedAlignments}>
            Refresh Elements
          </button>
        </div>


      {/* popups */}
      {alignmentStore.alignmentCopyModalOpen && (
        <AlignmentCopy id={vm.alignmentToCopy.id} name={vm.alignmentToCopy.name} />
      )}

      {vm.deleteAlignmentModalOpen && (
        <DeleteElement
          trigger={vm.deleteAlignmentModalOpen}
          setTrigger={vm.toggleDeleteAlignmentModal}
          element="alignment"
          name={vm.alignmentToDelete.designElementName}
          action={vm.deleteIndependentAlignment}
        />
      )}

      {vm.warningDialogIsOpen && (
        <Popup
          icon={mdiExitToApp}
          trigger={vm.warningDialogIsOpen}
          setTrigger={vm.toggleWarningDialog}
          title="You have unsaved changes"
          handleCancel={vm.warningDialogDiscardAction}
          cancelText="Discard"
          handleAction={vm.warningDialogReturnAction}
          actionText="Return to unsaved"
          handleOK={vm.warningDialogSaveAction}
          okText="Save"
        >
          <p>
            You have unsaved changes on alignment{' '}
            <span className="text-underline">{alignmentStore.currentElement.name}</span>.
          </p>
          <p>Do you want to discard, return to editing or save changes?</p>
        </Popup>
      )}
    </>
  );
};

export const AlignmentSummaryTable = observer(AlignmentSummaryTableComponent);
